import React from 'react';
import PropTypes from 'prop-types';

const DetailsRow = ({ label, value }) => {
  return (
    <tr>
      <th style={{ padding: '0 8px 0 0' }}>{label}</th>
      <td style={{ padding: 0 }}>{value}</td>
    </tr>
  );
};

DetailsRow.propTypes = {
  label: PropTypes.string,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
};

export default DetailsRow;
